import type { IntegrationSyncStatus } from "../types";
import { CrmIntegrationListStatus } from "../types";

export const calculateCrmListStatus = (
    syncStatus: IntegrationSyncStatus,
    isCrmListEnabled: boolean,
    isCurrentUserVerifiedByCrm: boolean,
): CrmIntegrationListStatus => {
    if (syncStatus === "NotIntegrated") {return CrmIntegrationListStatus.NotIntegrated;}
    if (!isCrmListEnabled) {return CrmIntegrationListStatus.NotActive;}
    if (!isCurrentUserVerifiedByCrm) {return CrmIntegrationListStatus.UnmatchedEmail;}
    if (syncStatus === "InProgress") {return CrmIntegrationListStatus.SyncInProgress;}
    return CrmIntegrationListStatus.Active;
};
